"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const SkewGraph = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#clip0_616_60447)"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  className: "fill",
  clipRule: "evenodd",
  d: "M4.354 6C5.059 5.378 5.985 5 7 5c1.017 0 1.946.38 2.652 1.005l1.917-1.917a2.5 2.5 0 11.354.353l-1.918 1.918C10.625 7.064 11 7.99 11 9a3.985 3.985 0 01-1 2.646l.774.774a2 2 0 11-.354.354L9.646 12c-.705.622-1.631 1-2.646 1a3.985 3.985 0 01-2.658-1.01l-1.629 1.628a1.5 1.5 0 11-.357-.35l1.634-1.634A3.985 3.985 0 013 9c0-1.015.378-1.941 1-2.646L2.37 4.723a1.5 1.5 0 11.354-.354L4.353 6z",
  fill: "#1973E8"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "clip0_616_60447"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _default = SkewGraph;
exports.default = _default;